import CryptoJS from "crypto-js";

const storeData = (data:string, name:string, secretKey?: string) => {
    const encryptedData = CryptoJS.AES.encrypt(data, secretKey || name).toString()
    localStorage.setItem(name, `${encryptedData}`)
    return encryptedData;
}
export default storeData;